export const environment = {
  production: false,
  ApiAppUrl: 'https://pnaubapidev.clavisco.com/',
  ApiUIUrl: 'https://pnaubdev.clavisco.com/',
  env : 'Development',
  recatchaSiteKey: '6Lf6MUorAAAAABoPD6pyUWWEM5uwzvLazV86CVtb',
  LogRocketId: ''
};
